import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TemplatesView } from '@/components/features/checklist-management/components/templates';

export const Route = createFileRoute('/_authenticated/checklist-management/templates')({
  component: ChecklistTemplates,
});

function ChecklistTemplates() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4 sm:gap-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-balance">
          {t('checklistManagement.templates.title')}
        </h1>
        <p className="text-xs sm:text-sm text-muted-foreground">
          {t('checklistManagement.templates.description')}
        </p>
      </div>
      <TemplatesView />
    </div>
  );
}
